/**
 * Note Copy Formatter.
 * @param {*} value
 * @param {object} row
 * @returns {string}
 */
window.copyFormatter = function(value, row) {
    let html = '';
    if (row.description) {
        html += '<a href="#" class="action action-copy" title="' + __('Copy description') + '">';
        html += '<i class="far fa-copy"></i>';
        html += '</a>';
    }
    return html;
}

window.copyEvents = {
    'click .action-copy': function(e, value, row) {
        e.preventDefault();

        navigator.clipboard.writeText(row.description).then(function() {
            Swal.fire({
                icon: 'success',
                title: __('Copied to clipboard.'),
                showConfirmButton: false,
                timer: 1500
            });
        });
    }
};
